export enum TachoType {
  CHART = 'CHART',
  TABLE = 'TABLE'
}
